import { useCallback } from 'react';

import { useUser } from 'modules/user/hooks/useUser';
import { useAppDispatch } from 'store/useAppDispatch';

import { AccountState } from '../types';
import {
  setIsAccountPremissionDialogHidden as setIsAccountPremissionDialogHiddenAction,
  setIsTeamAccountInitialized as setIsTeamAccountInitializedAction,
  setIsWorkerAuthorized as setIsWorkerAuthorizedAction,
  setTeamAccountAddress as setTeamAccountAddressAction,
  setUserEndpointToken as setUserEndpointTokenAction,
  setWorkerToken as setWorkerTokenAction,
} from '../store/accountSlice';

export const useAccountSetters = () => {
  const { address: authAddress } = useUser();

  const dispatch = useAppDispatch();

  const setTeamAccountAddress = useCallback(
    (teamAccountAddress: AccountState['teamAccountAddress']) => {
      if (authAddress) {
        dispatch(
          setTeamAccountAddressAction({
            authAddress,
            teamAccountAddress,
          }),
        );
      }
    },
    [dispatch, authAddress],
  );

  const setIsAccountPremissionDialogHidden = useCallback(
    (isAccountPermissionDialogHidden: boolean) => {
      if (authAddress) {
        dispatch(
          setIsAccountPremissionDialogHiddenAction({
            authAddress,
            isAccountPermissionDialogHidden,
          }),
        );
      }
    },
    [dispatch, authAddress],
  );

  const setIsTeamAccountInitialized = useCallback(
    (isTeamAccountInitialized: boolean) => {
      if (authAddress) {
        dispatch(
          setIsTeamAccountInitializedAction({
            authAddress,
            isTeamAccountInitialized,
          }),
        );
      }
    },
    [dispatch, authAddress],
  );

  const setIsWorkerAuthorized = useCallback(
    (isWorkerAuthorized: boolean) => {
      if (authAddress) {
        dispatch(
          setIsWorkerAuthorizedAction({ authAddress, isWorkerAuthorized }),
        );
      }
    },
    [dispatch, authAddress],
  );

  const setUserEndpointToken = useCallback(
    (userEndpointToken: AccountState['userEndpointToken']) => {
      if (authAddress) {
        dispatch(
          setUserEndpointTokenAction({ authAddress, userEndpointToken }),
        );
      }
    },
    [dispatch, authAddress],
  );

  const setWorkerToken = useCallback(
    (workerToken: AccountState['workerToken']) => {
      if (authAddress) {
        dispatch(setWorkerTokenAction({ authAddress, workerToken }));
      }
    },
    [dispatch, authAddress],
  );

  return {
    setIsAccountPremissionDialogHidden,
    setIsTeamAccountInitialized,
    setIsWorkerAuthorized,
    setTeamAccountAddress,
    setUserEndpointToken,
    setWorkerToken,
  };
};
